import { Component, AfterViewInit, OnDestroy, ElementRef } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { PermissionService } from 'src/app/services/permission.service';
import { Router } from '@angular/router';
declare const $: any;
import Tooltip from 'bootstrap/js/dist/tooltip';
@Component({
    selector: 'app-actions',
    templateUrl: './actions.component.html',
    styleUrls: ['./actions.component.css']
})
export class ActionsComponent implements AfterViewInit, OnDestroy {
    private tooltips: any[] = [];
    constructor(private PermissionService: PermissionService, private router: Router, private el: ElementRef<HTMLElement>) { }

    ngOnInit(): void {
    }
    ngAfterViewInit(): void {
        // Initialize Bootstrap 5 tooltips for elements within this component
        const tooltipTriggerList = Array.from(
            this.el.nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]')
        ) as HTMLElement[];
        this.tooltips = tooltipTriggerList.map(el => new Tooltip(el));
    }

    ngOnDestroy(): void {
        // Dispose tooltips to avoid memory leaks when AG Grid destroys the renderer
        this.tooltips.forEach(t => t.dispose());
        this.tooltips = [];
    }

    public cellValue!: any;

    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        this.cellValue = params;
    }

    // gets called whenever the user gets the cell to refresh
    refresh(params: ICellRendererParams) {
        // set value into cell again
        this.cellValue = "";
        return true;
    }

    deleteEvent() {
        this.cellValue.parent.actionDelete(this.cellValue.data.id)
    }
    canDo(module: string, action: string) {
        return this.PermissionService.canDo(module, action);
    }
    reportEvent(request: any) {
        this.router.navigateByUrl('/maintenance/coordinator/add', { state: { data: request } });
    }
    checklistEvent(request: any) {
        this.router.navigateByUrl('/unit/checklist', { state: { data: request } });
    }
    fuelConsumptionEvent(request: any) {
        this.router.navigateByUrl('/unit/fuel-consumption', { state: { data: request } });
    }
}
